const HEIC_EXT_RE = /\.heic$/i;
const HEIF_EXT_RE = /\.heif$/i;

export function isHeicLikeFile(file) {
  if (!(file instanceof File)) return false;
  const type = String(file.type || "").toLowerCase();
  if (type === "image/heic" || type === "image/heif") return true;
  const name = String(file.name || "");
  return HEIC_EXT_RE.test(name) || HEIF_EXT_RE.test(name);
}

function pickOutputName(file, ext) {
  const name = String(file?.name || "image");
  const base = name.replace(/\.[^.]+$/, "") || "image";
  return `${base}.${ext}`;
}

/**
 * Many browsers can't decode/preview HEIC/HEIF; normalize them to JPEG for preview + upload.
 * Returns the same File instance when no conversion is needed.
 */
export async function normalizeImageFileForUpload(file, { toType = "image/jpeg", quality = 0.86 } = {}) {
  if (!(file instanceof File)) return file;
  if (!isHeicLikeFile(file)) return file;

  const heic2any = (await import("heic2any")).default;
  const out = await heic2any({
    blob: file,
    toType,
    quality,
  });

  const blob = Array.isArray(out) ? out[0] : out;
  if (!(blob instanceof Blob)) return file;

  const ext = toType === "image/png" ? "png" : "jpg";
  return new File([blob], pickOutputName(file, ext), { type: toType });
}

